module.exports = __webpack_public_path__ + "static/media/MHRP09N0018.521c5213.svg";